import React, { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { UploadCloud, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label, testid, aspect = "aspect-video" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Image uploaded");
    } catch {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <label className="overline text-muted-foreground block mb-2">{label}</label>}
      <div
        className={`relative ${aspect} w-full rounded-md border border-white/10 bg-card overflow-hidden group cursor-pointer flex items-center justify-center`}
        onClick={() => inputRef.current?.click()}
        data-testid={testid}
      >
        {value ? (
          <>
            <img src={fileUrl(value)} alt="upload" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className="absolute top-2 right-2 bg-black/70 rounded-full p-1.5 hover:bg-primary transition-colors"
              data-testid={`${testid}-remove`}
            >
              <X className="w-4 h-4" />
            </button>
          </>
        ) : (
          <div className="flex flex-col items-center gap-2 text-muted-foreground">
            {uploading ? <Loader2 className="w-6 h-6 animate-spin" /> : <UploadCloud className="w-6 h-6" />}
            <span className="text-sm">{uploading ? "Uploading..." : "Click to upload"}</span>
          </div>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </div>
  );
}
